import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function WarningIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M22.2 17.634 14.001 3.396a2.322 2.322 0 0 0-4.002 0L1.8 17.634a2.205 2.205 0 0 0 0 2.223A2.283 2.283 0 0 0 3.801 21h16.398a2.283 2.283 0 0 0 2.301-2.255c0-.39-.104-.774-.3-1.111Zm-1.3 1.473a.795.795 0 0 1-.701.393H3.801a.795.795 0 0 1-.701-.393.711.711 0 0 1 0-.724l8.197-14.238a.821.821 0 0 1 1.407 0l8.199 14.238a.712.712 0 0 1-.005.723ZM11.25 13.5V9.75a.75.75 0 0 1 1.5 0v3.75a.75.75 0 1 1-1.5 0Zm1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
